module.exports = __webpack_public_path__ + "img/linkedin_btn.6f70a799.svg";